import React, { createContext, useContext, useState, useEffect } from 'react';

const ImageContext = createContext();

export const useImageContext = () => {
  const context = useContext(ImageContext);
  if (!context) {
    console.warn('useImageContext used outside ImageProvider, using fallback');
    return {
      imageUrls: {},
      isLoading: false,
      getImageUrl: (path) => path,
      checkImageExists: () => Promise.resolve(true),
      preloadImages: () => Promise.resolve()
    };
  }
  return context;
};

export const ImageProvider = ({ children }) => {
  const [imageUrls, setImageUrls] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Simple image URL function (direct loading)
  const getImageUrl = (imagePath) => {
    return imagePath; // Return path as-is for direct loading
  };

  // Check if image exists (simplified)
  const checkImageExists = async (imagePath) => {
    if (!imagePath) return false;
    return true; // Assume images exist for simplicity
  };

  // Preload images (simplified)
  const preloadImages = async (imagePaths) => {
    if (!imagePaths || imagePaths.length === 0) return;
    
    setIsLoading(true);
    const urls = {};
    
    imagePaths.forEach(imagePath => {
      urls[imagePath] = imagePath;
    });
    
    setImageUrls(prev => ({ ...prev, ...urls }));
    setIsLoading(false);
  };

  // Initialize on mount
  useEffect(() => {
    console.log('📸 ImageContext: Using direct image loading');
    setIsLoading(false);
  }, []);

  const value = {
    imageUrls,
    isLoading,
    getImageUrl,
    checkImageExists,
    preloadImages
  };

  return (
    <ImageContext.Provider value={value}>
      {children}
    </ImageContext.Provider>
  );
};

export default ImageContext;
